import { render, staticRenderFns } from "./WebpagesEdit.vue?vue&type=template&id=3a829b94&scoped=true&"
import script from "./WebpagesEdit.vue?vue&type=script&lang=js&"
export * from "./WebpagesEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebpagesEdit.vue?vue&type=style&index=0&id=3a829b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a829b94",
  null
  
)

export default component.exports